<div class="card">
  <div class="grid">
      <div class="col-12">
        <h5 class="m-0 text-5xl">Dashboard</h5>
      </div>
      <div class="col-6">
        <pg-monthly-sales-chart></pg-monthly-sales-chart>
      </div>
      <div class="col-6">
        <pg-sales-employ-business></pg-sales-employ-business>
      </div>
  </div>
</div>
